import VideoHero from "./VideoHero";

const VideoHeroWithProps = ({ blok }) => {
  return (
    <VideoHero
      title={blok.title}
      description={blok.description}
      ctas={blok.ctas}
      backgroundVideo={blok.backgroundVideo}
      backgroundPoster={blok.backgroundPoster}
    />
  );
};

export default VideoHeroWithProps;
